export function initialsFromName(name: string, maxLength = 2): string {
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .filter(Boolean)
    .join("")
    .slice(0, maxLength)
    .toUpperCase();
  return initials || "?";
}

export function humanizeSnakeCase(value: string): string {
  return value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}
function isBoilerplateLine(paragraph: string): boolean {
  if (/^[-=*_]{4,}$/.test(paragraph.replace(/\s/g, ""))) return true;
  if (paragraph.length <= 80 && paragraph === paragraph.toUpperCase() && /[A-Z]{3,}/.test(paragraph)) return true;
  if (/^NEWSLETTER\b/i.test(paragraph)) return true;
  if (/view\s+(this\s+)?email\s+in\s+(your\s+)?browser/i.test(paragraph)) return true;
  if (/^(unsubscribe|opt[- ]?out|manage\s+(your\s+)?preferences)/i.test(paragraph)) return true;
  if (/^\*{0,2}\s*(Website|Facebook|Instagram|LinkedIn|Twitter|YouTube|X)\s*\*{0,2}$/i.test(paragraph)) return true;
  if (/©|copyright\b/i.test(paragraph)) return true;
  if (/^\d+\s+\w+\s+(street|st|avenue|ave|road|rd|blvd|lane|ln)\b/i.test(paragraph)) return true;
  if (/^(sent from|powered by|sent via)\b/i.test(paragraph)) return true;
  if (paragraph.split(/\s+/).length === 1 && paragraph.length <= 20) return true;
  if (/^(contact|over de|about)\s*:/i.test(paragraph)) return true;
  return false;
}

export function decodeHtmlEntities(text: string): string {
  return text
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&apos;/gi, "'")
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(Number(dec)))
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
}

export function htmlToParagraphs(input: string): readonly string[] {
  let html = input
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "");

  html = html.replace(/<a\s[^>]*>([\s\S]*?)<\/a>/gi, "$1");

  const withBreaks = html
    .replace(/<\s*br\s*\/?>/gi, "\n")
    .replace(/<\s*\/p\s*>/gi, "\n\n")
    .replace(/<\s*p[^>]*>/gi, "")
    .replace(/<\s*\/?(div|tr|li|h[1-6])[^>]*>/gi, "\n");

  const stripped = withBreaks
    .replace(/<[^>]+>/g, " ")
    .replace(/\r/g, "");
  const decoded = decodeHtmlEntities(stripped);

  const lines = decoded
    .split(/\n{1,2}/)
    .map((paragraph) =>
      paragraph
        .replace(/\s*\(https?:\/\/[^\s)]+\)/g, "")
        .replace(/https?:\/\/[^\s]+/g, "")
        .replace(/\s+/g, " ")
        .trim(),
    )
    .filter((paragraph) => paragraph.length > 0);

  const result: string[] = [];
  let consecutiveBoilerplate = 0;
  for (const line of lines) {
    if (isBoilerplateLine(line)) {
      consecutiveBoilerplate++;
      if (consecutiveBoilerplate >= 3 && result.length > 0) break;
      continue;
    }
    consecutiveBoilerplate = 0;
    result.push(line);
    if (result.length >= 8) break;
  }

  return result;
}

export function normalizeSubject(subject: string): string {
  let normalized = subject;
  const prefix = /^(re|fwd|fw|antw|wg|ref)\s*:\s*/i;
  while (prefix.test(normalized)) {
    normalized = normalized.replace(prefix, "");
  }
  return normalized.trim();
}
